var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgU(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 30C0 13.4315 13.4315 0 30 0V0C46.5685 0 60 13.4315 60 30V30C60 46.5685 46.5685 60 30 60V60C13.4315 60 0 46.5685 0 30V30Z",
    fill: "#BBD1E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4526 19.6364H37.9185V33.1193C37.9185 34.5114 37.5903 35.7543 36.9341 36.848C36.2845 37.9351 35.3664 38.7936 34.1798 39.4233C32.9933 40.0464 31.6012 40.358 30.0037 40.358C28.4062 40.358 27.0141 40.0464 25.8276 39.4233C24.641 38.7936 23.7196 37.9351 23.0634 36.848C22.4137 35.7543 22.0889 34.5114 22.0889 33.1193V19.6364H24.5548V32.9205C24.5548 33.9148 24.7736 34.7997 25.2111 35.5753C25.6486 36.3442 26.2717 36.9508 27.0804 37.3949C27.8957 37.8324 28.8702 38.0511 30.0037 38.0511C31.1372 38.0511 32.1117 37.8324 32.927 37.3949C33.7423 36.9508 34.3654 36.3442 34.7963 35.5753C35.2338 34.7997 35.4526 33.9148 35.4526 32.9205V19.6364Z",
    fill: "#123C65"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgU);
export default __webpack_public_path__ + "static/media/u.74bdabb26e65d335805ce6ab93d00495.svg";
export { ForwardRef as ReactComponent };